
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/new-residents-orientation",
      function () {
        return require("private-next-pages/events/new-residents-orientation.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/new-residents-orientation"])
      });
    }
  